// 여러 화면에서 같이 쓰는 문구
const common = {
  ko: {
    documentTitle: '대한버추얼스포츠협회 | 대회 참가신청',
    orgName: '대한버추얼스포츠협회',
    save: '저장',
    cancel: '취소',
    close: '닫기',
    confirm: '확인',
    retry: '다시 시도',
    search: '검색',
    loading: '불러오는 중...',
    none: '없음',
    noGym: '무소속',
    male: '남',
    female: '여',
    maleFull: '남자',
    femaleFull: '여자',
    people: '{count}명',
    cm: '{value}cm',
    won: '{value}원',
    language: '언어',
    round: {
      final: '결승',
      ofN: '{n}강',
      matchList: '1:1 경기',
    },
    division: {
      male: '남자부',
      female: '여자부',
    },
  },
  en: {
    documentTitle: 'Korea Virtual Sports Association | Tournament Registration',
    orgName: 'Korea Virtual Sports Association',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'OK',
    retry: 'Try again',
    search: 'Search',
    loading: 'Loading...',
    none: 'None',
    noGym: 'No gym',
    male: 'M',
    female: 'F',
    maleFull: 'Male',
    femaleFull: 'Female',
    people: ({ count }) => `${count} ${Number(count) === 1 ? 'person' : 'people'}`,
    cm: '{value} cm',
    won: '₩{value}',
    language: 'Language',
    round: {
      final: 'Final',
      matchList: '1:1 match',
      ofN: ({ n }) =>
        Number(n) === 4 ? 'Semifinals' : Number(n) === 8 ? 'Quarterfinals' : `Round of ${n}`,
    },
    division: {
      male: 'Male',
      female: 'Female',
    },
  },
};

export default common;
